import Cookies from 'universal-cookie';
import { i18n } from 'next-i18next';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);
require('dayjs/locale/el');
dayjs.extend(relativeTime);

i18n?.init();
const lang = () => {
  return i18n?.language === 'en' ? dayjs.locale('en') : dayjs.locale('el');
};

export const getCookie = (name: string) => {
  const cookies = new Cookies();
  return cookies.get(name);
};

export const dateFromNow = (value: Date) => {
  const cookieValue = getCookie('timeZone') ? getCookie('timeZone') : 'Europe/Athens';
  lang();
  dayjs.tz.setDefault(cookieValue);
  const convertedToTimezone = value ? dayjs.tz(value) : '';
  return dayjs(cookieValue === 'Europe/Athens' ? value : convertedToTimezone)
    .startOf('second')
    .fromNow();
};

export default dateFromNow;
